const LandingSet = {
  title1: {
    English: "HR analytics self-assessment",
    German: "Selbstbewertungstool",
    French: "Outil d’auto-évaluation",
    Russian: "Инструмент для самостоятельной",
    Turkish: "Finansal",
    Italian: "Strumento di autovalutazione",
    Spanish: "Herramienta de autoevaluación",
    PortugueseBR: "Ferramenta de autoavaliação",
    SpanishLAD: "Herramienta de autoevaluación",
  },
  title2: {
    English: "Self-Assessment",
    German: "für das Finanzwesen",
    French: "financière",
    Russian: "оценки финансовых процессов",
    Turkish: "öz değerlendirme aracı",
    Italian: "del Finance",
    Spanish: "de los procesos financieros",
    PortugueseBR: "financeira",
    SpanishLAD: "financiera",
  },
  landingCopy: {
    English:
      "In an ever-changing work environment, you have questions about the people and processes that make your organization successful.  Analytics makes it fast and easy to get the answers you need from across the organization, which can help HR leaders better recruit, retain, and forecast talent needs."
  },
  landingCopy2: {
    English:
      "Use this tool to score your organization’s people analytics strategy and learn how to be analytic-driven with your HR Data.",
  },
  getStarted: {
    English: "Get Started",
    German: "Loslegen",
    French: "Commencer",
    Russian: "Начать",
    Turkish: "Başla",
    Italian: "Inizia",
    Spanish: "Comenzar",
    PortugueseBR: "Comece já",
    SpanishLAD: "Introducción",
  },
  restartBtn: {
    English: "Restart",
    German: "Neustarten",
    French: "Recommencer",
    Russian: "Начать сначала",
    Turkish: "Tekrar Başlat",
    Italian: "Ricomincia",
    Spanish: "Reiniciar",
    PortugueseBR: "Reiniciar",
    SpanishLAD: "Reiniciar",
  },
  nextBtn: {
    English: "Next",
    German: "Weiter",
    French: "Suivant",
    Russian: "Далее",
    Turkish: "Sonraki",
    Italian: "Avanti",
    Spanish: "Siguiente",
    PortugueseBR: "Avançar",
    SpanishLAD: "Siguiente",
  },
  finishBtn: {
    English: "Finish",
    German: "Beenden",
    French: "Terminer",
    Russian: "Завершить",
    Turkish: "Bitir",
    Italian: "Termina",
    Spanish: "Finalizar",
    PortugueseBR: "Concluir",
    SpanishLAD: "Finalizar",
  },
};

export default LandingSet;
